import { Component, Input } from '@angular/core';

@Component({
  selector: 'cs-loading',
  standalone: false,
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
  @Input()
  public isLoading: boolean;

  @Input()
  public loader: 'circle' | 'cube' | 'flip' = 'circle';

  @Input()
  public displayMessage: string;

  @Input()
  public isLoadTop: boolean = false;
}
